import { createFeature, createReducer, on } from '@ngrx/store';
import { CalificacionesActions } from './calificaciones.actions';
import { CalificacionesState, initialCalificacionesState } from './calificaciones.state';

const reducer = createReducer(
  initialCalificacionesState,
  on(CalificacionesActions.loadGrades, (state, { studentId }) => ({
    ...state, studentId, loading: true, error: null,
  })),
  on(CalificacionesActions.loadGradesSuccess, (state, { grades }) => ({
    ...state, grades, loading: false,
  })),
  on(CalificacionesActions.loadGradesFailure, (state, { error }) => ({
    ...state, loading: false, error,
  })),
);

export const calificacionesFeature = createFeature<'calificaciones', CalificacionesState>({
  name: 'calificaciones',
  reducer,
});
